import { isCreating, getCreateError, isUpdating, getUpdateError, isCreatingRegex, getCreateErrorRegex } from './_utils'

// notifiers
export const creatingRenewPassword = (state) => isCreating('/password_renewal')(state)
export const updatingRenewPassword = (state) => isUpdating('/password_renewal')(state)
export const getCreateRenewPasswordError = (state) => getCreateError('/password_renewal')(state)
export const getUpdateRenewPasswordError = (state) => getUpdateError('/password_renewal')(state)

export const validatingAccount = (state) => isCreating('/accounts/validate')(state)
export const getValidateAccountError = (state) => getCreateError('/accounts/validate')(state)

// register
export const registeringUser = (state) => isCreating('/register')(state)
export const getRegisterError = (state) => getCreateError('/register')(state)
export const getEmailValidationResendError = (state, email) => getCreateError(`/accounts/validate/${email}`)(state)

// login
export const loggingIn = (state) => isCreatingRegex(/\/login/)(state)
export const getLoginError = (state) => getCreateErrorRegex(/\/login/)(state)
